import React, { useState, useEffect, useContext, useMemo } from "react";
import { Link } from "react-router-dom";
import { LangContext } from "../../context/lang-context";
import useFetch from "../../hooks/fetchMSSQL-hook";
import moment from "moment";
import { NavigationContext } from "../../context/navigation-context";
import { FlatTable } from "../../components/FlatTable/FlatTable";
import SearchFilter from "../../components/Filter/SearchFilter";
import ReportButton from "../../components/Buttons/ReportButton";

const DOS = () => {
  const { TRL_Pack } = useContext(LangContext);
  const { fetchMssqlApi } = useFetch();
  const { setHeaderData } = useContext(NavigationContext);
  const [DOS, setDOS] = useState([]);

  const defaultAdditionalFilter = {do: '', user: '', date: '', machine: '', loadQuantity: '', state: '', inm: ''};
  const [additionalFilter, setAdditionalFilter] = useState(defaultAdditionalFilter);

  const reportList = [
    { reportId: 47, reportColor: "primary" },
    { reportId: 48, reportColor: "danger" },
    { reportId: 60, reportColor: "success" },
    { reportId: 74, reportColor: "dark" },
    { reportId: 78, reportColor: "info" },
  ].filter(Boolean);

  const defaultFilter = {
    dateTimeRangeFrom: moment().startOf("day").format("YYYY-MM-DDTHH:mm:ss"),
    dateTimeRangeTo: moment().endOf("day").format("YYYY-MM-DDTHH:mm:ss"),
    name: "dos",
    page: 1,
    sortBy: "none",
    machineId: null,
    machineName: "",
    machineTags: { id: [], name: [] },
    userId: null,
    userName: "",
  };

  const [filter, setFilter] = useState(defaultFilter);
  const [settingsFilter, setSettingsFilter] = useState();

  useEffect(() => {
    setHeaderData({ text: "Doładowania" });
  }, []);

  const getMachineIdsByTags = (machineTagIds) => {
    return new Promise((resolve, reject) => {
      fetchMssqlApi(
        "tags/getMachineIdsByTags",
        { method: "POST", hideNotification: true, data: { machineTagIds } },
        (response) => { resolve(JSON.stringify(response.map(Number).filter(Number.isFinite)) || [])},
        (err) => reject(err)
      );
    });
  };

  const sortDefaults = {
    DO: "ASC",
    CreateDateTime: "DESC",
    MachineFullName: "ASC",
    LoadQuantity: "DESC",
    StatePercent: "DESC",
  };

  const getSortState = () => {
    const [field, dir] = String(filter.sortBy || "").split("|");
    return { field, dir: (dir || "").toUpperCase() };
  };

  const sortState = getSortState();

  const arrow = (field) => {
    if (sortState.field !== field) return "";
    return sortState.dir === "ASC" ? " ▲" : " ▼";
  };

  const handleHeaderSort = (field) => {
    const [curField, curDirRaw] = String(filter.sortBy || "").split("|");
    const curDir = (curDirRaw || "").toUpperCase();

    let nextDir;
    if (curField === field) {
      nextDir = curDir === "ASC" ? "DESC" : "ASC";
    } else {
      nextDir = sortDefaults[field] || "ASC";
    }

    const next = { ...filter, sortBy: `${field}|${nextDir}`, page: 1 };
    setFilter(next);
    getDOS(next, null, 1);
  };

  const getDOS = async (f, pageSize, page) => {
    let rowsPerPage = settingsFilter?.rowsPerPage ?? 100;
    if (pageSize != null) rowsPerPage = pageSize;
    const pageNo = Math.max(1, Number(page ?? f?.page) || 1);
    let machineIds = "[]";
    if (f?.machineTags?.id?.length > 0) { machineIds = await getMachineIdsByTags(f.machineTags.id)} 
    if (f?.machineId) {const arr = JSON.parse(machineIds); arr.push(Number(f.machineId)); machineIds = JSON.stringify(arr);}
    fetchMssqlApi(
      "dos",
      {
        method: "POST",
        hideNotification: true,
        data: {
          machineIds,
          createUserId: f?.userId,
          fromCreateDateTime: f?.dateTimeRangeFrom,
          toCreateDateTime: f?.dateTimeRangeTo,
          pageSize: rowsPerPage,
          pageNo,
          sortBy: f?.sortBy,
        },
      },
      (response) => setDOS(response || [])
    );
  };

  const filtered = useMemo(() => {
    return DOS?.filter(item =>
      (additionalFilter.do === '' || `${item.DO || ''}`.toLowerCase().includes(additionalFilter.do.toLowerCase())) &&
      (additionalFilter.user === '' || `${item.CreatedBy || ''}`.toLowerCase().includes(additionalFilter.user.toLowerCase())) &&
      (additionalFilter.date === '' || `${item.LocalCreateDateTime || ''}`.toLowerCase().includes(additionalFilter.date.toLowerCase())) &&
      (additionalFilter.machine === '' || `${item.MachineFullName || ''}`.toLowerCase().includes(additionalFilter.machine.toLowerCase())) &&
      (additionalFilter.loadQuantity === '' || `${item.LoadQuantity || ''}`.toLowerCase().includes(additionalFilter.loadQuantity.toLowerCase())) &&
      (additionalFilter.state === '' || `${item.StateAndCapacity || ''} ${item.StatePercent || ''}%`.toLowerCase().includes(additionalFilter.state.toLowerCase())) &&
      (additionalFilter.inm === '' || `${item.INm || ''}`.toLowerCase().includes(additionalFilter.inm.toLowerCase()))
    ) ?? [];
  }, [DOS, additionalFilter]);

  return (
    <>
      <SearchFilter
        filterName="DOS"
        defaultFilter={defaultFilter}
        reportList={reportList}
        onFilterChange={(f) => setFilter((prev) => ({ ...prev, ...f }))}
        onSettingsChange={(s) => setSettingsFilter((prev) => ({ ...prev, ...s }))}
        search={getDOS}
        totalCount={DOS.length}
        defaultAdditionalFilter={defaultAdditionalFilter}
        additionalFilter={additionalFilter}
        onAdditionalFilterChange={(af) => setAdditionalFilter(af)}
        forNow
      />
      <div style={{maxHeight: "calc(100vh - 120px)", overflowY: "auto"}}>
        <table className="table table-striped custom-scroll" >
          <colgroup>
            <col style={{ minWidth: "155px", width: "155px" }}/>
            <col style={{ minWidth: "180px"}}/>
            <col style={{ minWidth: "160px", width: "160px" }}/>
            <col style={{ minWidth: "300px"}}/>
            <col style={{ minWidth: "100px", width: "100px" }}/>
            <col style={{ minWidth: "170px", width: "170px" }}/>
            <col style={{ minWidth: "170px", width: "170px" }}/>
            <col style={{ minWidth: "100px", width: "100px", maxWidth: "100px" }}/>
          </colgroup>
          <thead>
            <tr className="text-center headers-color">
              <th className='align-middle p-1 m-1'>
                <span style={{cursor: "pointer", userSelect: "none"}} onClick={() => handleHeaderSort("DO")}>Doładowanie{arrow("DO")}</span><br/>
                <input type="text" value={additionalFilter.do || ""} onChange={({ target: { value } }) => setAdditionalFilter(prev => ({...prev, do: value}))} className={`additional-filter-input ${additionalFilter.do ? "additional-filter-input-active" : ""}`}/>
              </th>
              <th className='align-middle p-1 m-1'>
                <span style={{cursor: "pointer", userSelect: "none"}} onClick={() => handleHeaderSort("User")}>Serwisant{arrow("User")}</span><br/>
                <input type="text" value={additionalFilter.user || ""} onChange={({ target: { value } }) => setAdditionalFilter(prev => ({...prev, user: value}))} className={`additional-filter-input ${additionalFilter.user ? "additional-filter-input-active" : ""}`}/>
              </th>
              <th className='align-middle p-1 m-1'>
                <span style={{cursor: "pointer", userSelect: "none"}} onClick={() => handleHeaderSort("CreateDateTime")}>Czas zapisu{arrow("CreateDateTime")}</span><br/>
                <input type="text" value={additionalFilter.date || ""} onChange={({ target: { value } }) => setAdditionalFilter(prev => ({...prev, date: value}))} className={`additional-filter-input ${additionalFilter.date ? "additional-filter-input-active" : ""}`}/>
              </th>
              <th className='align-middle p-1 m-1'>
                <span style={{cursor: "pointer", userSelect: "none"}} onClick={() => handleHeaderSort("MachineFullName")}>Automat{arrow("MachineFullName")}</span><br/>
                <input type="text" value={additionalFilter.machine || ""} onChange={({ target: { value } }) => setAdditionalFilter(prev => ({...prev, machine: value}))} className={`additional-filter-input ${additionalFilter.machine ? "additional-filter-input-active" : ""}`}/>
              </th>
              <th className='align-middle p-1 m-1'>
                <span style={{cursor: "pointer", userSelect: "none"}} onClick={() => handleHeaderSort("LoadQuantity")}>Doładowano{arrow("LoadQuantity")}</span><br/>
                <input type="text" value={additionalFilter.loadQuantity || ""} onChange={({ target: { value } }) => setAdditionalFilter(prev => ({...prev, loadQuantity: value}))} className={`additional-filter-input ${additionalFilter.loadQuantity ? "additional-filter-input-active" : ""}`}/>
              </th>
              <th className='align-middle p-1 m-1'>
                <span style={{cursor: "pointer", userSelect: "none"}} onClick={() => handleHeaderSort("StatePercent")}>Stan automatu{arrow("StatePercent")}</span><br/>
                <input type="text" value={additionalFilter.state || ""} onChange={({ target: { value } }) => setAdditionalFilter(prev => ({...prev, state: value}))} className={`additional-filter-input ${additionalFilter.state ? "additional-filter-input-active" : ""}`}/>
              </th>
              <th className='align-middle p-1 m-1'>
                <span style={{cursor: "pointer", userSelect: "none"}} onClick={() => handleHeaderSort("INm")}>INm{arrow("INm")}</span><br/>
                <input type="text" value={additionalFilter.inm || ""} onChange={({ target: { value } }) => setAdditionalFilter(prev => ({...prev, inm: value}))} className={`additional-filter-input ${additionalFilter.inm ? "additional-filter-input-active" : ""}`}/>
              </th>
              <th>
              </th>
            </tr>
          </thead>

          <tbody>
            {filtered.map((entry, idx) => (
              <tr key={idx} className="text-center align-middle">
                <td className="p-1">
                  <Link to={`/do/${entry.MachineLoadMachineInventoryId}`} className="btn text-nowrap btn-sm btn-outline-info">{entry.DO}</Link>
                </td>
                <td className="p-1">{entry.CreatedBy}</td>
                <td className="p-1">{entry.LocalCreateDateTime}</td>
                <td className="p-1">
                  <Link to={`/machine/${entry.MachineId}`} className="btn btn-sm btn-outline-secondary">{entry.MachineFullName}</Link>
                </td>
                <td className="p-1">{entry.LoadQuantity ?? "-"}</td>
                <td className="p-1">
                  {entry.INm &&  `${entry.StateAndCapacity} ${entry.StatePercent}%`}
                </td>
                <td className="p-1">
                  <div className="d-flex flex-column justify-content-center align-items-center">
                    {entry.INm && <Link to={`/inm/${entry.MachineInventoryId}`} className="btn text-nowrap btn-sm btn-outline-danger">{entry.INm}</Link>}
                  </div>
                </td>

                <td className="p-1">
                  <ReportButton reportId={74} btnColor="dark" isPrimary body={() => ({fromCreateDateTime: filter?.dateTimeRangeFrom, toCreateDateTime: filter?.dateTimeRangeTo, loadMachineInventoryId: entry.MachineLoadMachineInventoryId})}/>
                  <ReportButton reportId={70} btnColor="outline-dark" isPrimary body={() => ({loadMachineInventoryId: entry.MachineLoadMachineInventoryId})}/>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default DOS;